import { createSelector } from 'reselect';
import precise from '../modules/precise';
import secondYearFeeTotal from './secondYearFeeTotal.selector';

const BaseFeeSel = state => state.registration.BaseFee;
const svcTotalSel = state => state.registration.SVCFEE_TOTAL;
const applySecondYearFeeSel = state => state.registration.applySecondYearFee;
const secondYearFeeSel = state => secondYearFeeTotal(state);
const creditTotalSel = state => state.registration.creditTotal;
const applyCreditSel = state => state.registration.applyCredit;
const mobileHomeLengthSel = state => state.mobilehome.mobileHomeLength;
const vehicleWeightFeeSel = state => state.registration.vehicleWeightFee;
const vesselShowExemptFeeSel = state => state.registration.vesselShowExemptFee;
const vesselCommercialFeeSel = state => state.registration.vesselCommercialFee;
const vesselCommercialExemptSel = state => state.registration.vesselCommercialExempt;


const subtotalFeesCreditSelector = createSelector(
  [
    BaseFeeSel,
    svcTotalSel,
    applySecondYearFeeSel,
    secondYearFeeSel,
    creditTotalSel,
    applyCreditSel,
    mobileHomeLengthSel,
    vehicleWeightFeeSel,
    vesselCommercialFeeSel,
    vesselShowExemptFeeSel,
    vesselCommercialExemptSel,
  ],
  (
    base,
    svc,
    applySecondYear,
    secondYearFee,
    creditTotal,
    applyCredit,
    mobileHomeLength,
    vehicleWeightFee,
    vesselCommercialFee,
    vesselShowExemptFee,
    vesselCommercialExempt,
  ) => {
    let total = Number(base) + Number(svc) + Number(vehicleWeightFee);

    if (applySecondYear) {
      total += Number(secondYearFee);
    }

    if (vesselShowExemptFee && !vesselCommercialExempt) {
      total += Number(vesselCommercialFee);
    }

    if (applyCredit) {
      total += Number(creditTotal);
    }

    return precise(Number(total) * mobileHomeLength);
  },
);

export default subtotalFeesCreditSelector;



// WEBPACK FOOTER //
// ./src/selectors/subtotalFeesAndCredit.selector.js